export default __webpack_public_path__ + "static/media/linkedIn.44fd07f2.svg";